// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__8DT0J","name":"Header_name__AqQbg","birthday":"Header_birthday__MS5iY","skeleton":"Header_skeleton__1pZsz"};